import 'owl.carousel';
import 'slick-carousel';
import 'magnific-popup';
import moment from 'moment';

jQuery(document).ready(function ($) {
	// Menu
	$('a[href^="#"]').on('click', function (e) {
		e.preventDefault();
		const href = $(this).attr('href');
		$('html, body').animate({
			scrollTop: $(href).offset().top
		}, 2000);
	});
	// Music
	$('.slider-music').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></button>',
		// responsive: [
		// 	{
		// 		breakpoint: 992,
		// 		settings: {
		// 			slidesToShow: 3,
		// 		}
		// 	}
		// ]
	});
	// Videos
	$('#watch .owl-carousel').owlCarousel({
		items: 1,
		loop: true,
		dots: false,
		nav: true,
		margin: 20,
		startPosition: 1
	});

	// Follow
	$.ajax({
		url: 'https://www.juicer.io/api/feeds/sephschlueter',
		method: 'GET',
		dataType: 'json',
		success: function (data) {
			if (data.posts.items.length > 0) {
				let i = 0;
				let html = '';
				for (let item of data.posts.items) {
					html += '<div>';
					html += '<a href="' + item.full_url + '" target="_blank">';
					html += '<img src="' + item.image + '" alt="' + item.external_id + '" />';
					html += '</a>';
					html += '</div>';
					i++;
					if (i >= 8) {
						break;
					}
				}
				$('#instagram_posts').html(html);
			}
		},
		error: function () {
			alert('An error has occurred fetching Instagram posts!');
		}
	});

	// Events
	$.ajax({
		url: 'https://rest.bandsintown.com/artists/id_15532941/events?app_id=45PRESS_Seph',
		method: 'GET',
		dataType: 'json',
		error: () => {
			alert('Error fetching events!');
		},
		success: data => {
			console.log(data);
			const events = $('#events');
			let html = '';
			if (data.length) {
				for (let event of data) {
					let location = event.venue.city + ', ' + event.venue.region;
					if (location === ', ') { location = ''; }
					if (event.venue.name.toLowerCase() === 'streaming live') { location = 'Online'; }
					event.lineup.splice('Seph Schlueter', 1)
					let guest = event.lineup.join(', ');
					html += '<div class="event">';
					html += '<div class="event-date">' + moment(event.datetime).format('MMMM D, Y') + '<div class="support">' + guest + '</div>' + '</div>';
					html += '<div class="event-info">';
					html += '<div class="event-location">' + '<div class="event-venue">' + event.venue.name + '</div>' + location + '</div>';
					html += '</div>';
					html += '<div class="event-links">';
					for (let offer of event.offers) {
						html += '<a href="' + offer.url + '" target="_blank" class="btn btn-light">' + offer.type + '</a>';
					}
					html += '</div>';
					html += '</div>';
				}
				events.html(html);
			} else {
				events.html('No upcoming events.');
			}
		}
	});

	// POPUP
	// Store the element that triggered the popup
	let lastFocusedElement;

	// Update the modal implementation in main.js
	$.magnificPopup.open({
		items: {
			src: '#newsletter-popup'
		},
		type: 'inline',
		fixedContentPos: true,
		callbacks: {
			open: function () {
				// Save focus to return it later
				lastFocusedElement = document.activeElement;

				// Set ARIA attributes
				$('#newsletter-popup').attr('role', 'dialog')
					.attr('aria-modal', 'true')
					.attr('aria-labelledby', 'newsletter-title');

				// Get all focusable elements inside modal
				const $modal = $('#newsletter-popup');
				const focusable = $modal.find('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
				const first = focusable.first()[0];
				const last = focusable.last()[0];

				// Set initial focus on first focusable element
				setTimeout(function () {
					first.focus();
				}, 50);

				// Trap focus in modal
				$modal.on('keydown.focus-trap', function (e) {
					if (e.key === 'Tab') {
						if (e.shiftKey) {
							if (document.activeElement === first) {
								e.preventDefault();
								last.focus();
							}
						} else {
							if (document.activeElement === last) {
								e.preventDefault();
								first.focus();
							}
						}
					} else if (e.key === 'Escape') {
						$.magnificPopup.close();
					}
				});
			},
			close: function () {
				// Remove focus trap
				$('#newsletter-popup').off('keydown.focus-trap');

				// Return focus to the element that opened the modal
				if (lastFocusedElement) {
					lastFocusedElement.focus();
				}
			}
		}
	});

	// Fan Submission Popup
	$.magnificPopup.open({
		items: {
			src: '#fan-submission-popup'
		},
		type: 'inline',
		fixedContentPos: true
	});


	// Form Logic
	$(".seph-schlueter-newsletter-code").on("submit", function (e) {
		e.preventDefault();

		var data = $(this).serialize();
		console.log('form package', data)

		$.ajax({
			type: "POST",
			url: "https://subs.sonymusicfans.com/submit",
			dataType: "json",
			data: data,
			xhrFields: {
				withCredentials: false
			},
			success: function (data) {
				// Do things on successful submission.
				$(".seph-schlueter-newsletter-code .inputs-wrap").hide()
				$(".seph-schlueter-newsletter-code .form-message").fadeIn()
			},
			error: function (err) {
				// Do things when submission has an error.
				alert("An error has occured!");
			}
		});
	});

	$(".seph-schlueter-newsletter-code-pop").on("submit", function (e) {
		e.preventDefault();

		var data = $(this).serialize();
		console.log('form package', data)

		$.ajax({
			type: "POST",
			url: "https://subs.sonymusicfans.com/submit",
			dataType: "json",
			data: data,
			xhrFields: {
				withCredentials: false
			},
			success: function (data) {
				// Do things on successful submission.
				$(".seph-schlueter-newsletter-code-pop .inputs-wrap").hide()
				$(".seph-schlueter-newsletter-code-pop .form-message").fadeIn()
			},
			error: function (err) {
				// Do things when submission has an error.
				alert("An error has occured!");
			}
		});
	});

});
